<p-dialog [header]="'chatgptDialog.getAiInspiredDescriptions' | transloco" [modal]="true" [(visible)]="displayDialog" (onHide)="onDialogClosed()"
  [style]="{ width: '520px' }">
  @if ((isArtist || isGallery) && artistProductId) {
    <div class="p-3">
      @if (artistProductId) {
        <div class="form-group">
          <label class="form-label" for="shortProductHint">{{ 'chatgptDialog.shortHint' | transloco }}</label>
          <textarea id="shortProductHint" name="shortProductHint" rows="3" class="form-control"
            [(ngModel)]="request.HintContent"
            [placeholder]="'chatgptDialog.shortHintPlaceholder' | transloco">
          </textarea>
        </div>
      }
      <div class="form-group w-50 mt-2">
        <label class="form-label mb-2">{{ 'chatgptDialog.selectTone' | transloco }}</label>
        <p-dropdown [options]="availableTonesOptions" name="tone" [(ngModel)]="request.Tone"
          [style]="{'width': '100%'}" appendTo="body" [editable]="true">
        </p-dropdown>
      </div>
      <div class="mt-4 fw-semibold">{{ 'chatgptDialog.alsoIncludeInChatGptRequest' | transloco }}</div>
      <div>{{ 'chatgptDialog.forMoreAccurateResponse' | transloco }}</div>
      <div class="row mt-2">
        <div class="col-4">
          <!-- Series Checkbox -->
          @if (artistProductId) {
            <div class="form-group mt-1">
              <p-checkbox name="series" [binary]="true" [label]="'chatgptDialog.series' | transloco" [(ngModel)]="request.IncludeProductSeries">
              </p-checkbox>
            </div>
          }
          <div class="form-group mt-1">
            <p-checkbox name="artistProfile" [binary]="true" [label]="'chatgptDialog.artistProfile' | transloco"
              [(ngModel)]="request.IncludeArtistProfile">
            </p-checkbox>
          </div>
        </div>
        <div class="col-4">
          @if (artistProductId) {
            <div class="form-group mt-1">
              <p-checkbox name="features" [binary]="true" [label]="'chatgptDialog.features' | transloco"
                [(ngModel)]="request.IncludeProductFeatures">
              </p-checkbox>
            </div>
          }
          <div class="form-group mt-1">
            <p-checkbox name="mainImage" [binary]="true" [label]="'chatgptDialog.productImage' | transloco" [disabled]="true"
              [(ngModel)]="request.IncludeProductCoverPhoto">
            </p-checkbox>
          </div>
        </div>
        <div class="col-4">
          @if (artistProductId) {
            <div class="form-group mt-1">
              <p-checkbox name="material" [binary]="true" [label]="'chatgptDialog.material' | transloco"
                [(ngModel)]="request.IncludeProductMaterial">
              </p-checkbox>
            </div>
          }
        </div>
      </div>
      <!-- Buttons -->
      <div class="d-flex justify-content-end align-items-center mt-4">
        <button pButton type="button" [label]="'chatgptDialog.cancel' | transloco"
        class="p-button p-button-secondary p-button-sm p-button-outlined" (click)="onDialogClosed()"></button>
        <!-- <button pButton type="button" label="Ask ChatGPT" class="p-button p-button-sm p-button-outlined ms-2"
      (click)="generateChatGPTContent($event, true)"></button> -->
      <button pButton type="button" [label]="'chatgptDialog.askAi' | transloco"
        class="p-button p-button-success p-button-sm p-button-outlined ms-2"
      (click)="generateChatGPTContent($event, false)"></button>
    </div>
    <!-- ChatGPT Response Section -->
    @if (showSuggestions) {
      <div class="border-top mt-5 mb-2">
        <h4 class="py-2">{{ 'chatgptDialog.aiSuggestions' | transloco }}</h4>
        <div class="form-group mt-2">
          <label class="form-label" for="generatedShortDescription">{{ 'chatgptDialog.shortDescription' | transloco }}</label>
          <textarea id="generatedShortDescription" name="generatedShortDescription" rows="3" class="form-control"
          [(ngModel)]="gptGeneratedResponse.ShortDescription"></textarea>
        </div>
        <div class="form-group mt-2">
          <label class="form-label" for="marketingDescription">{{ 'chatgptDialog.marketingDescription' | transloco }}</label>
          <textarea id="marketingDescription" name="marketingDescription" rows="5" class="form-control"
          [(ngModel)]="gptGeneratedResponse.MarketingDescription"></textarea>
        </div>
        <div class="form-group mt-2">
          <label class="form-label" for="socialMediaPostDescription">{{ 'chatgptDialog.socialMediaDescription' | transloco }}</label>
          <textarea id="socialMediaPostDescription" name="socialMediaPostDescription" rows="5"
          class="form-control" [(ngModel)]="gptGeneratedResponse.SocialMediaPostDescription"></textarea>
        </div>
        <div class="d-flex justify-content-end align-items-center mt-2">
          <button pButton class="p-button-outlined p-button-secondary p-button-sm" [label]="'chatgptDialog.tryAgain' | transloco"
          (click)="generateChatGPTContent($event, false)"></button>
          <button pButton class="p-button-outlined p-button-danger p-button-sm ms-2" [label]="'chatgptDialog.useIt' | transloco"
          (click)="useChatGPTSuggestion($event)"></button>
        </div>
      </div>
    }
  </div>
}
@if (isGallery && galleryProductId) {
  <div class="p-3">
    @if (galleryProductId) {
      <div class="form-group">
        <label class="form-label" for="shortProductHint">{{ 'chatgptDialog.shortHint' | transloco }}</label>
        <textarea id="shortProductHint" name="shortProductHint" rows="3" class="form-control"
          [(ngModel)]="galleryRequest.HintContent"
          [placeholder]="'chatgptDialog.shortHintPlaceholder' | transloco">
        </textarea>
      </div>
    }
    <div class="form-group w-50 mt-2">
      <label class="form-label mb-2">{{ 'chatgptDialog.selectTone' | transloco }}</label>
      <p-dropdown [options]="availableTonesOptions" name="tone" [(ngModel)]="galleryRequest.Tone"
        [style]="{'width': '100%'}" appendTo="body" [editable]="true">
      </p-dropdown>
    </div>
    <div class="mt-4 fw-semibold">{{ 'chatgptDialog.alsoIncludeInChatGptRequest' | transloco }}</div>
    <div>{{ 'chatgptDialog.forMoreAccurateResponse' | transloco }}</div>
    <div class="row mt-2">
      <div class="col-4">
        <div class="form-group mt-1">
          <p-checkbox name="artistProfile" [binary]="true" [label]="'chatgptDialog.galleryProfile' | transloco"
            [(ngModel)]="galleryRequest.IncludeGalleryProfile">
          </p-checkbox>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group mt-1">
          <p-checkbox name="mainImage" [binary]="true" [label]="'chatgptDialog.productImage' | transloco" [disabled]="true"
            [(ngModel)]="galleryRequest.IncludeProductCoverPhoto">
          </p-checkbox>
        </div>
      </div>
    </div>
    <!-- Buttons -->
    <div class="d-flex justify-content-end align-items-center mt-4">
      <button pButton type="button" [label]="'chatgptDialog.cancel' | transloco"
      class="p-button p-button-secondary p-button-sm p-button-outlined" (click)="onDialogClosed()"></button>
      <!-- <button pButton type="button" label="Ask ChatGPT" class="p-button p-button-sm p-button-outlined ms-2"
    (click)="generateChatGPTContent($event, true)"></button> -->
    <button pButton type="button" [label]="'chatgptDialog.askAi' | transloco"
      class="p-button p-button-success p-button-sm p-button-outlined ms-2"
    (click)="generateChatGPTContent($event, false)"></button>
  </div>
  <!-- ChatGPT Response Section -->
  @if (showSuggestions) {
    <div class="border-top mt-5 mb-2">
      <h4 class="py-2">{{ 'chatgptDialog.aiSuggestions' | transloco }}</h4>
      <div class="form-group mt-2">
        <label class="form-label" for="generatedShortDescription">{{ 'chatgptDialog.shortDescription' | transloco }}</label>
        <textarea id="generatedShortDescription" name="generatedShortDescription" rows="3" class="form-control"
        [(ngModel)]="gptGeneratedResponse.ShortDescription"></textarea>
      </div>
      <div class="form-group mt-2">
        <label class="form-label" for="marketingDescription">{{ 'chatgptDialog.marketingDescription' | transloco }}</label>
        <textarea id="marketingDescription" name="marketingDescription" rows="5" class="form-control"
        [(ngModel)]="gptGeneratedResponse.MarketingDescription"></textarea>
      </div>
      <div class="form-group mt-2">
        <label class="form-label" for="socialMediaPostDescription">{{ 'chatgptDialog.socialMediaDescription' | transloco }}</label>
        <textarea id="socialMediaPostDescription" name="socialMediaPostDescription" rows="5"
        class="form-control" [(ngModel)]="gptGeneratedResponse.SocialMediaPostDescription"></textarea>
      </div>
      <div class="d-flex justify-content-end align-items-center mt-2">
        <button pButton class="p-button-outlined p-button-secondary p-button-sm" [label]="'chatgptDialog.tryAgain' | transloco"
        (click)="generateChatGPTContent($event, false)"></button>
        <button pButton class="p-button-outlined p-button-danger p-button-sm ms-2" [label]="'chatgptDialog.useIt' | transloco"
        (click)="useChatGPTSuggestion($event)"></button>
      </div>
    </div>
  }
</div>
}
</p-dialog>
<p-dialog [(visible)]="aiDescriptionDailogVisible" [header]="'chatgptDialog.upgradeYourAccount' | transloco" [closable]="true" [modal]="true"
  [style]="{'width': '450px'}" (onHide)="onCloseLimitDailog($event)">
  <div class="dialog-content">
    <!-- Warning Section -->
    <div class="alert alert-warning p-4 rounded-3 border-0 shadow-lg mb-4">
      <div class="d-flex align-items-center">
        <i class="pi pi-info-circle text-warning fs-3 me-3"></i>
        <div>
          <strong>{{ 'chatgptDialog.upgradeNeeded' | transloco }}</strong>
          <p class="mb-2">{{ 'chatgptDialog.reachedAiDescriptionLimit' | transloco }}</p>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <p class="lead p-2">
      {{ 'chatgptDialog.unlockExclusiveFeatures' | transloco }}
    </p>

    <!-- Features List -->
    <ul class="text-muted mt-2 px-3">
      @if (isArtist) {
        <li>{{ 'chatgptDialog.unlimitedAiDescriptionsForArtists' | transloco }}</li>
      }
      @if (isGallery) {
        <li>{{ 'chatgptDialog.unlimitedAiDescriptionsForGalleries' | transloco }}</li>
      }
    </ul>

    <!-- Upgrade CTA -->
    <div class="text-center mt-4">
      <a href="javascript:void(0);" (click)="ShowUpgradeDailog()">
        <img src="assets/images/upgrade-nag-button-200h.png" width="300" [alt]="'chatgptDialog.upgradePlan' | transloco"
          class="rounded shadow-lg img-fluid" />
        </a>
      </div>

    </div>
  </p-dialog>



  @if (isStripeDisplayPlansDialogVisible) {
    <stripe-payment-plan [isStripePaymentPlansDialogVisible]="isStripeDisplayPlansDialogVisible"
      [stripeAllPlans]="stripePlans"
    (onCloseStripePaymentPlanDailog)="onCloseStripePaymentDailog($event)"></stripe-payment-plan>
  }